/**
 * LocalStorageService wraps up window.localStorage object.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  public namespace: string = 'global/';
  /**
   * Storage getter.
   *
   * @param key - property name.
   * @return Parsed data.
   */
  public getItem(key: any): any {
    const namespace = this.namespace;
    let value;
    try {
      value = localStorage.getItem(namespace + key);
    } catch (e) {}

    return value ? JSON.parse(value) : null;
  }
  /**
   * Storage setter.
   *
   * @param key - property name.
   * @param value - property value.
   * @return Parsed data.
   */
  public setItem(key: any, value: any): any {
    const namespace = this.namespace;
    const data = JSON.stringify(value);
    let result = null;
    try {
      localStorage.setItem(namespace + key, data);
      result = JSON.parse(data);
    } catch (e) {}

    return result;
  }
  /**
   * Remove item from storage by property name.
   *
   * @param key - property name.
   */
  public removeItem(key: any): void {
    const namespace = this.namespace;
    try {
      localStorage.removeItem(namespace + key);
    } catch (e) {}
  }
}
